import { ArrowLeft, ArrowRight } from "lucide-react";
import { useState } from "react";
import AlbumIndication from "./AlbumIndication";

type imageAlbumProps = {
    imageUrls: string[];
}

export default function ImageAlbum({imageUrls}: imageAlbumProps) {
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
    const firstImage = currentImageIndex === 0;
    const lastImage = currentImageIndex === imageUrls.length-1;

    debug(imageUrls, firstImage, lastImage, currentImageIndex)
    return (
        <div className="relative">
     
            <div
                className="flex h-full transition-transform duration-200 ease-in-out"
                style={{
                    width: `${imageUrls.length * 100}%`,
                    transform: `translateX(-${currentImageIndex * (100 / imageUrls.length)}%)`
                }}
            >
                {imageUrls.map((url, i) => (
                <div className="relative w-full h-[45vh] overflow-hidden bg-black">
                {/* Background blur layer */}
                <img
                    src={url}
                    className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-60"
                />

                {/* Foreground image */}
                <img
                    src={url}
                    className="relative w-full h-full object-contain"
                />
                </div>
                ))}
            </div>

            <button 
                className={`absolute top-1/2 -translate-y-1/2 left-5 p-3 bg-black/60 rounded-full ${!firstImage && 'hover:bg-black/80'} z-[2600] transition-all ease-in-out duration-200`}
                onClick={() => {
                    if (!firstImage) setCurrentImageIndex(prev => prev - 1)}
                }
                disabled={firstImage}
            >
                <ArrowLeft className={`${firstImage ? 'text-gray-500/80' : 'text-white/80'} `}/>
            </button>
            <button 
                className={`z-[2600] absolute top-1/2 -translate-y-1/2 right-5 p-3 bg-black/60 rounded-full ${!lastImage && 'hover:bg-black/80'} transition-all ease-in-out duration-200`}
                onClick={() => {
                    if (!lastImage) setCurrentImageIndex(prev => prev + 1)}
                }
                disabled={lastImage}
            >
                <ArrowRight className={`${lastImage ? 'text-gray-500/80' : 'text-white/80'} `}/>
            </button>      
            <div className="`z-[2600] absolute bottom-6 -translate-x-1/2 left-1/2">
                <AlbumIndication album={imageUrls} currentPhoto={currentImageIndex}/>
            </div>
        </div>
    )
}